import 'pace-progress/themes/blue/pace-theme-minimal.css';
import 'pace-progress/pace.js';

import 'font-awesome/css/font-awesome.min.css';

import $ from 'jquery';
import 'jquery-ui';
import 'jquery-ui/ui/widgets/draggable';

import 'expose-loader?angular!angular';
import 'angular-route';
import 'angular-sanitize';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap';

import '../css/nifty.css';
import './nifty.js';

import 'footable/css/footable.core.min.css';
import 'footable/dist/footable.all.min.js';
import 'angular-footable';

import 'angular-material';
import 'angular-material/angular-material.min.css';
import 'angular-moment';

import 'chart.js';
import 'angular-chart.js';
import 'ng-table/dist/ng-table.min.css';
import 'ng-table';
import 'ngmap';
import 'angularjs-scroll-glue';
import 'nvd3/build/nv.d3.min.css';
import 'nvd3';
import 'angular-nvd3';
import 'angular-messages';
import '@brunoalevato/nggallery/src/css/ngGallery.css';
import '@brunoalevato/nggallery/src/js/ngGallery.js';
import 'angular-gettext';

import 'toastr/build/toastr.min.css';
import 'toastr';

import 'file-saver';

import './app.js';
import './routes.js';

import 'speed-test/js/speedTest.js';
import 'h2g-test-history/js/test-history.js';
import 'h2g-test-results/js/test-results.js';
import 'h2g-material/dialogs/js/wtg-dialog.js';
import 'traceroute/js/traceroute.js';
import 'wifi-spectrum/js/wifi-spectrum.js';

import './controllers/orbitUtil.js';

import './controllers/main.js';
import './controllers/support-queue.js';
import './controllers/support-chat.js';
import './controllers/support-tabs.js';
import './controllers/tab-diagnostics.js';
import './controllers/tab-apps.js';
import './controllers/tab-remote-security.js';
import './controllers/support-show.js';
import './controllers/login-ctrl.js';
import './controllers/register-ctrl.js';
import './controllers/dashboard.js';
import './controllers/tab-device.js';
import './controllers/tab-mdm.js';
import './controllers/tab-circle.js';
import './controllers/analytics.js';
import './controllers/mpacter.js';
import './controllers/router-config.js';
import './controllers/localscan.js';
import './controllers/misc.js';

import './modules/misc.js';
import './modules/U.js';
import './modules/interact.js';
import './modules/intractable.js';
import './modules/ida.js';
import './modules/persistence.js';

import './services/event-handler-factory.js';

import './directives.js';

import './translations.js';

import '../css/circle.css';
import '../css/style.css';
import 'speed-test/css/speedTest.css';
import 'router-config/htdocs/css/rc_style.css';
import 'h2g-linear-view/css/main_screen.css';
import 'h2g-test-history/css/test-history.css';
import 'h2g-material/css/util.css';
import 'traceroute/css/traceroute.css';
import 'wifi-spectrum/css/wifi-spectrum.css';
import 'lan-scan/css/device-details.css';
import 'lan-scan/css/device-list.css';
import '../css/overlay-menu.css';

import '../css/theme.css';
import '../the-style.css';

var wtgcp = (typeof WTGCONFIG !== 'undefined')?WTGCONFIG.support_agent:null;
if (wtgcp){
 $('#navbar-title').text(wtgcp.navbar_title);
 $(document).ready(function() {
  document.title = document.title.replace("WebToGo", wtgcp.page_title);
 });
}
$("#videocallmodal").draggable({
 handle: ".modal-header"
});


if(module.hot) {
 module.hot.accept(()=>window.location.reload);
}
